import React, { useState, useEffect } from "react";
import NotesHandler from "./components/NotesHandler";
import Settings from "./components/Settings";
import {
  applyTheme,
  applyDaypart,
  loadTheme,
  THEME_KEY,
  DEFAULT_THEME,
} from "./utils/themes";
import { applyUIFontSize, normalizeUIFontSize } from "./utils/fontSize";
import { initFeedback } from "./delight/feedback";
import { PREF_KEYS } from "./prefs";

// Apply saved settings once at startup (the inline script in index.html already
// set the theme before first paint; this also resolves older theme ids)
applyTheme(loadTheme());
try {
  applyUIFontSize(
    normalizeUIFontSize(localStorage.getItem("settings:fontSize")),
  );
  // Leftovers from older versions
  ["currentUser", "thinkloop-shutdown-banner-dismissed", "settings:font", "activeTab"].forEach(
    (key) => localStorage.removeItem(key),
  );
} catch {}
applyDaypart();

// Sounds, haptics, sparkle and stretch for every press, key and hover
initFeedback();

function App() {
  // Settings opens as a dialog over the notes, like ModelLoop's
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Meadow's background follows the time of day
  useEffect(() => {
    const interval = setInterval(applyDaypart, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  // Listen for storage changes from other browser tabs
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === THEME_KEY) {
        applyTheme(e.newValue || DEFAULT_THEME);
      } else if (e.key === PREF_KEYS.motion) {
        if (e.newValue === "reduce") document.documentElement.dataset.motion = "reduce";
        else delete document.documentElement.dataset.motion;
      } else if (e.key === "settings:fontSize") {
        applyUIFontSize(normalizeUIFontSize(e.newValue));
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <div className="App">
      <NotesHandler onOpenSettings={() => setSettingsOpen(true)} />
      {settingsOpen && <Settings onClose={() => setSettingsOpen(false)} />}
    </div>
  );
}

export default App;
